import { render, staticRenderFns } from "./OperaPermissionWindow.vue?vue&type=template&id=d8da7f04&"
import script from "./OperaPermissionWindow.vue?vue&type=script&lang=js&"
export * from "./OperaPermissionWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports